import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../../core/utils/material.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChangePasswordDialogComponent } from './change-password-dialog.component';
import { MatError, MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { PasswordStrengthComponent } from '../password-strength/password-strength.component';
import { StrengthIndicatorComponent } from '../password-strength/strength-indicator.component';


@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    
    
   ],
  entryComponents: [
    
       ],
  declarations: [
    ChangePasswordDialogComponent,
    PasswordStrengthComponent,
    StrengthIndicatorComponent
  ],
  exports: [
    ChangePasswordDialogComponent,
    PasswordStrengthComponent,
    StrengthIndicatorComponent
  ]
})
export class changePwdSharedModule { }
